(ns quuppa.qsm.ui-state.events
  (:require [re-frame.core :as rf]))

(rf/reg-event-db ::update
  (fn [db [_ page-key f & args]]
    (apply update-in db [:ui-state page-key] f args)))

(rf/reg-event-db ::update-in
  (fn [db [_ path f & args]]
    (apply update-in db (concat [:ui-state] path) f args)))

(rf/reg-event-db ::assoc-in
  (fn [db [_ path value]]
    (assoc-in db (cons :ui-state path) value)))

(rf/reg-event-db ::set-sidebar-type
  ;; will clear whole :sidebar datastructure
  (fn [db [_ page-key sidebar-type]]
    (assoc-in db [:ui-state page-key :sidebar] {:type sidebar-type})))

(rf/reg-event-db ::init-sidebar-form
  (fn [db [_ page-key form-key init-data]]
    (assoc-in db [:ui-state page-key :sidebar form-key] init-data)))

(rf/reg-event-db ::set-sidebar-form-field
  (fn [db [_ page-key form-key field value]]
    (assoc-in db [:ui-state page-key :sidebar form-key field] value)))

(rf/reg-event-db ::close-sidebar
  (fn [db [_ page-key]]
    (assert page-key "Missing page key for ::close-sidebar")
    (update-in db [:ui-state page-key] dissoc :sidebar)))

